const user = [
    {
        path: '/user',
        name: 'user',
        component: () => import('@/view/user/Index'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/user/order',
        name: 'userOrder',
        component: () => import('@/view/user/Order'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/user/course',
        name: 'userCourse',
        component: () => import('@/view/user/Course'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/user/problem',
        name: 'userProblem',
        component: () => import('@/view/user/Problem'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/user/ask',
        name: 'userAsk',
        component: () => import('@/view/user/Ask'),
        meta: {
            requireAuth: true
        }
    },
    {
        path: '/user/wrong',
        name: 'userWrong',
        component: () => import('@/view/user/Wrong'),
        meta: {
            requireAuth: true
        }
    }
]
export default user